// Tailwind base classes for the native form controls. These mirror the geometry
// and colors of the SCSS modules they replaced, so the migration off Bootstrap's
// .form-control is visually a no-op; only the focus ring is new.
//
// INPUT_BASE also suits a <select> or <textarea> sitting in a field grid, since
// all three should share one height. SELECT_BASE is the compact variant, and is
// inline-block rather than w-full because the table filters and the generic
// selector set their own width.

export const INPUT_BASE =
  'w-full rounded border border-input bg-white px-3 py-1.5 text-sm text-body placeholder:text-muted-text' +
  ' focus:outline-none focus:ring-1 focus:ring-ring focus:border-ring' +
  ' disabled:cursor-not-allowed disabled:opacity-50'

export const SELECT_BASE =
  'inline-block h-8 rounded border border-chrome bg-white px-2 text-sm text-body' +
  ' focus:outline-none focus:ring-1 focus:ring-ring focus:border-ring' +
  ' disabled:cursor-not-allowed disabled:bg-surface-hover disabled:text-muted-text'

// A twelve-column grid for a form section. Fields claim their width with a
// `col-span-*` at the breakpoint that suits their content; below `sm` every
// field is full width.
export const FIELD_GRID = 'grid grid-cols-1 items-start gap-x-6 gap-y-4 sm:grid-cols-12'
